import React, { useState, useRef, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { TitleText } from '../../../ui/Text';
import DateRange from '../../../ui/DateRange';
import { LearningIcon } from '../../../assets/svg/LearningIcon';
import { FinancialIcon } from '../../../assets/svg/FinancialIcon';
import { CustomerIcon } from '../../../assets/svg/CustomerIcon';
import { ProcessesIcon } from '../../../assets/svg/ProcessesIcon';
import Header from '../components/Header';
import Modal from '../../../ui/Modal';
import {
  NavLink,
  useRouteMatch,
  useParams,
  useLocation
} from 'react-router-dom';
import { GetHook, postEndpoint } from '../../../api/api';
import {
  PERSPECTIVE_URL,
  SCORECARD_URL,
  SCORECARDS_URL
} from '../../../api/urls';
import Axios from '../../../utils/axios';
import { get } from '../../../utils/get';
import AddPerspective from './AddPerspective';
import { Button } from '../../../ui/Button';
import DropdownButton from '../../../ui/DropDownButton';
import { EditDeleteFormatter } from '../../../ui/TableFormatter';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { AuthContext } from '../../../context/AuthContext';
import { is360Subject } from '../../../subjects/Is360Subject';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/animations/scale-subtle.css';
import DocumentUpload from '../../../ui/DocumentUpload';
import { sortPerspectives } from '../../../utils/sortPerspectives';
import useAuth from '../../../hooks/useAuth';

interface IProps {
  openPreviewModal?: any;
}

const PerspectiveComponent = ({ openPreviewModal }: IProps) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isUploadModalOpen, setisUploadModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [perspectives, setPerspectives] = useState<any>([]);
  const [scorecard, setScorecard] = useState<any>([]);
  const [kpis, setKpis] = useState<any>([]);

  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>([]);

  const { id }: any = useParams();
  const { url } = useRouteMatch();
  const location = useLocation();

  const auth = useAuth();
  const { isAdmin, isManager, authState } = auth;

  const { data, error, pending, reload } = GetHook(
    `${SCORECARD_URL}/${id}/perspective/v1`
  );

  const fetchScorecard = () => {
    Axios.get(`${SCORECARD_URL}/${id}`).then(res => {
      const { returned_resultset } = get(res, 'data');
      setScorecard(returned_resultset);
    });
  };

  const fetchKpis = () => {
    Axios.get(`${SCORECARD_URL}/${id}/kpi/v1`).then(res => {
      const { returned_resultset } = get(res, 'data');
      setKpis(returned_resultset);
    });
  };

  useEffect(() => {
    if (id) {
      fetchScorecard();
      fetchKpis();
    }
    return () => {};
  }, [id]);

  useEffect(() => {
    setPerspectives(data);

    return () => {};
  }, [data]);

  const setEdit = perspective => {
    setIsEdit(true);
    setEditData(perspective);
    setisModalOpen(true);
  };
  const closeModal = () => {
    setisModalOpen(false);
    setisUploadModalOpen(false);
    setIsEdit(false);
    setEditData({});
    reload(get(location, 'key'));
  };

  const handleDelete = perspective_id => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.value) {
        if (id) {
          Axios.delete(`${SCORECARD_URL}/${id}/perspective/${perspective_id}`)
            .then(res => {
              setPerspectives(
                perspectives.filter(
                  (perspective: any) => perspective?.perspective_id != id
                )
              );
              toast.success('Perpsective has been deleted');
              reload(get(location, 'key'));
            })
            .catch(error => toast.error(error.response.data.message));
        }
      }
    });
  };

  const handleApprove = () => {
    Axios.put(`${SCORECARD_URL}/${id}`, { status: 'active' }).then(res => {
      toast.success('Scorecard approved');
      setScorecard(res.data.returned_resultset);
      reload(get(location, 'key'));
      console.log(res.data.returned_resultset);
    });
  };

  const handleArchive = () => {
    Axios.put(`${SCORECARD_URL}/${id}`, { status: 'archived' }).then(res => {
      toast.success('Scorecard archived');
      setScorecard(res.data.returned_resultset);
      reload(get(location, 'key'));
    });
  };

  const handleReject = () => {
    Axios.put(`${SCORECARD_URL}/${id}`, { status: 'draft' }).then(res => {
      toast.success('Scorecard rejected');
      setScorecard(res.data.returned_resultset);
      reload(get(location, 'key'));
    });
  };

  const handleRequest = () => {
    Axios.put(`${SCORECARD_URL}/${id}`, { status: 'pending-approval' }).then(
      res => {
        toast.success('Approval request sent');
        setScorecard(res.data.returned_resultset);
        reload(get(location, 'key'));
      }
    ).catch(function (error) {
      // Handle error  
        toast.error(error.response.data.message);
      
    
    });
  };


  const handlePIP = () => {
    Axios.put(`${SCORECARD_URL}/${id}`, { status: 'PIP' }).then(res => {
      toast.success('Scorecard set to PIP.');
      setScorecard(res.data.returned_resultset);
      reload(get(location, 'key'));
    });
  };


  const scorecardWeght = kpis.map(function (i) {
    return Number(i.normalised_weight);
  });
  let Objsum = 0;

  for (let i = 0; i < scorecardWeght?.length; i++) {
    Objsum += Math.round(scorecardWeght[i] * 100);
  }

  const sortedPerspectives = sortPerspectives(perspectives);
  return (
    <PerspectiveConatiner>
      <ProfileContainer>
        <ProfileImageSection>
          <ProfileImage
            src={
              scorecard[0]?.owner.avatar_url ||
              'https://previews.123rf.com/images/nexusby/nexusby1810/nexusby181000286/111362910-default-avatar-placeholder-profile-icon-male.jpg'
            }
          />
          <ProfileDetailsUsername>
            <TitleText>{scorecard[0]?.owner.names}</TitleText>
            <TitleText
              style={{ fontSize: 12, paddingTop: '2em' }}
              color='#cdd3de'
            >
              {/* {scorecard && get(scorecard[0], "owner.job_title")} */}
            </TitleText>
          </ProfileDetailsUsername>
        </ProfileImageSection>
        <>
          <TitleText color='#cdd3de'>Period</TitleText>
          <TitleText>{scorecard && get(scorecard[0], 'period.name')}</TitleText>
        </>
       
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            columnGap: '1em',
            paddingBottom: '1em',
            height: '1em'
          }}
        >
          {get(scorecard[0], 'owner_id') === get(authState, 'user.id') &&
          get(scorecard[0], 'status') === 'draft' ? (
            <DropdownButton
              isDraft
              status={'Request approval'}
              request={handleRequest}
              openModal={openPreviewModal}
            />
          ) : get(scorecard[0], 'owner_id') === get(authState, 'user.id') &&
            (get(scorecard[0], 'status') === 'active' ||
              get(scorecard[0], 'status') === 'pending-approval') ? (
            <LabelButton
              backgroundColor='#81ECC3'
              text={
                get(scorecard[0], 'status') === 'active'
                  ? 'Approved'
                  : 'Pending'
              }
            />
          ) : get(scorecard[0], 'status') === 'active' && !isAdmin() ? (
            <LabelButton
              backgroundColor='#81ECC3'
              text={
                get(scorecard[0], 'status') === 'active'
                  ? 'Approved'
                  : 'Pending'
              }
            />
          ) : isAdmin() ? (
            <DropdownButton
              approve={handleApprove}
              reject={handleReject}
              pip={handlePIP}
              archive={handleArchive}
              isManager={isManager()}
              isAdmin={isAdmin()}
              status={
                scorecard && get(scorecard[0], 'status') === 'active'
                  ? 'Approved'
                  : 'Approve'
              }
            />
          ) : isManager() ? (
            <DropdownButton
              approve={handleApprove}
              reject={handleReject}
              archive={handleArchive}
              isManager={isManager()}
              isAdmin={isAdmin()}
              status={
                scorecard && get(scorecard[0], 'status') === 'active'
                  ? 'Approved'
                  : 'Approve'
              }
            />
          ) : null}
        
        </div>
      </ProfileContainer>

      <Header
        title='Perspectives'
        count={perspectives && perspectives.length}
        setisModalOpen={setisModalOpen}
        isEdit={isEdit}
        handleDelete={handleDelete}
      />
      {isModalOpen && (
        <Modal
          title={isEdit ? 'Edit Pespective' : 'Create Perspective'}
          closeModal={closeModal}
          handleSubmit={handleSubmit}
        >
          <AddPerspective
            setHandleSubmit={setHandleSubmit}
            setPerspectives={setPerspectives}
            perspective={perspectives}
            closeModal={closeModal}
            editData={editData}
          />
        </Modal>
      )}
      <Perspectives>
        {sortedPerspectives &&
          sortedPerspectives.map((perspective: any) => (
            <PerspectiveItem
              key={perspective?.id}
              to={`${url}/perspective/${perspective?.perspective_id}`}
            >
              <TitleText style={{ fontSize: '12px' }}>
                {perspective?.perspective.name}
              </TitleText>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TitleText
                  style={{
                    marginRight: '1em',
                    color: '#D51067',
                    fontWeight: 'normal'
                  }}
                >
                  {perspective?.weight}
                </TitleText>
                <LearningIcon />
                <span
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <EditDeleteFormatter
                    showEdit={() => setEdit(perspective)}
                    isActive={
                      (get(scorecard, '[0]status') === 'active' || get(scorecard, '[0]status') === 'pending-approval' ) ? true : false
                    }
                    handleDelete={() =>
                      handleDelete(perspective?.perspective_id)
                    }
                  />
                </span>
              </div>
            </PerspectiveItem>
          ))}
      </Perspectives>
      {isUploadModalOpen && (
        <Modal
          noFooter
          // noHeader
          title='upload performance contract'
          closeModal={closeModal}
        >
          <DocumentUpload scorecardId={id} closeModal={setisUploadModalOpen} />
        </Modal>
      )}
    </PerspectiveConatiner>
  );
};

export default PerspectiveComponent;

const PerspectiveConatiner = styled.div`
  display: grid;
  grid-template-rows: 18em 5em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;
const ProfileContainer = styled.div`
  display: grid;
  /* grid-template-rows: 6em 1.5em 1.5em; */
  padding: 1em;
  padding-top: 2.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
const ProfileImageSection = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1fr;
`;

const ProfileImage = styled.img`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  padding: 15px;
`;

const ProfileDetailsUsername = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: column;
`;

const Perspectives = styled.ul`
  display: grid;
  grid-template-rows: repeat(auto-fill, 4.3125em);
  padding: 0;
  margin: 0;
  list-style: none;
`;

const PerspectiveItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.4em;
  text-decoration: none;
  &.active {
    background-color: #ebefff;
  }
`;

const LabelButton = styled(Button)`
  /* width: 50%; */
`;

const ButtonWithBorder = styled.button<{ disabled: boolean }>`
  border: 2px solid #01a8ce;
  padding: 0.3em 2em;
  margin-left: auto;
  font-size: 12px;
  margin-right: 1em;
  background-color: white;
  color: #214060;
  border-radius: 0.5em;
  font-weight: 700;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
